import {
  AutomationActionEnrollInExperienceDenormalized,
  IAutomationActionTemplateEnrollInExperience
} from '@dadohr/shared/domainTypes/experience';
import { useUnsafeTranslation } from '../../../../../../../i18next';
import { useCurrentUser } from '../../../../../../../services/currentUser';
import {
  getTplAdminTitle,
  useExperienceTemplateById
} from '../../../../../../../services/experiences/template';
import { useMappedLoadingValue } from '../../../../../../../services/firebase';
import { LightMdToJsx } from '../../../../../../../services/formatter';
import { hasCurrentUserExperienceLevelScopes } from '../../../../../../../services/permissions';
import { useActorDescriptorsFromTemplate } from '../../../../Actors';
import { MinimalTaskBuilderContext } from '../../../TaskBuilder/types';
import { ActionDefinition } from '../../types';
import {
  ActionSummaryBody,
  ActionSummaryContainer,
  ActionSummaryHeading
} from '../shared';

export const ActionSummaryEnrollInExperience = ({
  a,
  expTpl,
  def,
  currentTemplateId
}: {
  a:
    | IAutomationActionTemplateEnrollInExperience
    | AutomationActionEnrollInExperienceDenormalized;
  expTpl: MinimalTaskBuilderContext;
  def: ActionDefinition;
  currentTemplateId?: string;
}) => {
  const currentUser = useCurrentUser();
  const { t } = useUnsafeTranslation();
  const actorDescriptors = useActorDescriptorsFromTemplate(
    expTpl.supportingActors
  );
  const actor = actorDescriptors[a.actorToEnroll] || null;
  const isReenroll =
    currentTemplateId && a.tplToEnrollIn === currentTemplateId;
  const [tpl] = useMappedLoadingValue(
    useExperienceTemplateById(
      a.tplToEnrollIn || '_____TPL_ID_WHICH_DOES_NOT_EXIST_____' // cannot call with empty id
    ),
    (tpl) => {
      if (
        tpl &&
        !hasCurrentUserExperienceLevelScopes(currentUser, tpl.id, ['view'])
      ) {
        return null;
      }
      return tpl;
    }
  );
  return (
    <ActionSummaryContainer>
      <ActionSummaryHeading def={def} />
      <ActionSummaryBody>
        <LightMdToJsx>
          {isReenroll
            ? t('Re-enroll **{{ actor }}** in this experience', {
                actor: actor?.label || '...'
              })
            : t('Enroll **{{ actor }}** in **{{ experience }}**', {
                actor: actor?.label || '...',
                experience: tpl ? getTplAdminTitle(tpl) : '...'
              })}
        </LightMdToJsx>
      </ActionSummaryBody>
    </ActionSummaryContainer>
  );
};
